import HomePageContentManager from '../dashboard/components/HomePageContentManager';

export default function AdminContentPage() {
  return (
    <div className="space-y-6 max-w-full min-w-0">
      <HomePageContentManager />
    </div>
  );
}
